import { FrontendProjects } from 'common-typescript/types';

export const environment = {
    production: true,
    frontendName: 'STUDENT' as FrontendProjects,
};
